module.exports = __webpack_public_path__ + "static/img/c_img_1.0834f7c6.png";